/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_shipment = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_shipment" | "PdpRespShippingReturns_shipment">;
    readonly " $refType": "PdpRespContainer_shipment";
};
export type PdpRespContainer_shipment$data = PdpRespContainer_shipment;
export type PdpRespContainer_shipment$key = {
    readonly " $data"?: PdpRespContainer_shipment$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_shipment">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_shipment",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_shipment",
      "args": null
    }
  ]
};
(node as any).hash = '420fd2aa2770bf47e7c888011c42b0e9';
export default node;
